import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';
import { Globals } from 'src/app/shared/globals/globals';
import { Field, HeaderSection } from 'src/app/shared/models/data/documentTemplate';
import { createDocumentEditor, DOCUMENT_TEMPLATE_TOOLBAR } from 'src/app/shared/ngx-editor/document-template-editor';



@Component({
  selector: 'app-header-section',
  templateUrl: './header-section.component.html',
  styleUrls: ['./header-section.component.scss']
})
export class HeaderSectionComponent implements OnInit, OnDestroy {
  @Input() reset!: () => void;
  @Input() header: any = {
    topSection: { fields: {} },
    middleSection: { fields: {} },
    bottomSection: { isModified: false, value: '' }
  };
  @Output() headerChange = new EventEmitter<HeaderSection>();

  editor: Editor = createDocumentEditor();
  toolbar: Toolbar = DOCUMENT_TEMPLATE_TOOLBAR;

  constructor(public globals: Globals) {
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  onFieldChange(section: string, fieldKey: string, value: any) {
    this.header[section].fields[fieldKey].value = value;
    this.header[section].fields[fieldKey].isModified = true;
    this.headerChange.emit(this.header);
  }

  getFieldsKeys(sectionKey: string): string[] {
    return Object.keys(this.header[sectionKey].fields);
  }

  isVisible(field: Field): boolean {
    return !field.hidden && !field.hideable;
  }

  toggleFieldVisibility(section: string, fieldKey: string): void {
    const field = this.header[section].fields[fieldKey];
    field.hidden = !field.hidden;
    this.headerChange.emit(this.header);
  }

  onBottomSectionChange(newValue: string) {
    this.header.bottomSection.value = newValue;
    this.headerChange.emit(this.header);
  }

}
